export const openZendeskChat = () => {
  if (document.getElementById('ze-snippet') && zE) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerText = 'zE("messenger", "open");';
    script.async = true;
    document.body.appendChild(script);
  }
}

export const hideZendeskChat = () => {
  if (document.getElementById('ze-snippet') && zE) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerText = 'zE("messenger", "hide");';
    script.async = true;
    document.body.appendChild(script);
  }
}